"use client";

/**
 * AlertDetailShell — layout for /alerts/[id].
 *
 *   AlertTopBar (passed as header)
 *   AlertViewSwitcher
 *   active panel (Dashboard | Description | Canvas)
 */

import { useSearchParams } from "next/navigation";
import {
  AlertViewSwitcher,
  parseAlertViewTab,
  type AlertViewTab,
} from "./AlertViewSwitcher";
import { AlertDashboardView } from "./AlertDashboardView";
import { AlertDescriptionView } from "./AlertDescriptionView";

export function AlertDetailShell({
  alertId,
  header,
  canvas,
  isOwner = false,
  initialExplanationMd = null,
  scheduleText = null,
  notificationEmail = null,
  viewMode,
}: {
  alertId: string;
  header: React.ReactNode;
  canvas: React.ReactNode;
  isOwner?: boolean;
  initialExplanationMd?: string | null;
  scheduleText?: string | null;
  notificationEmail?: string | null;
  viewMode?: string;
}) {
  const searchParams = useSearchParams();
  const tab: AlertViewTab = parseAlertViewTab(searchParams?.get("tab") ?? null);

  return (
    <div className="flex flex-col h-full min-h-0">
      {header}
      <div
        className="flex-1 min-h-0 overflow-hidden"
        data-alert-panel
        data-alert-tab={tab}
      >
        {tab === "dashboard" && <AlertDashboardView alertId={alertId} isOwner={isOwner} viewMode={viewMode} />}
        {tab === "description" && (
          <AlertDescriptionView
            alertId={alertId}
            initialExplanationMd={initialExplanationMd}
            scheduleText={scheduleText}
            notificationEmail={isOwner ? notificationEmail : null}
            canEdit={isOwner}
            viewMode={viewMode}
          />
        )}
        {tab === "canvas" && canvas}
      </div>
    </div>
  );
}
